import { render, staticRenderFns } from "./hall_data_statistics.vue?vue&type=template&id=0c6a60c2&scoped=true"
import script from "./hall_data_statistics.vue?vue&type=script&lang=js"
export * from "./hall_data_statistics.vue?vue&type=script&lang=js"
import style0 from "./hall_data_statistics.vue?vue&type=style&index=0&id=0c6a60c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a60c2",
  null
  
)

export default component.exports